import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './faq.css';

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay },
  }),
};

export default function Faq() {
    const faqs = [
        {
            question: "Existe-t-il un risque de concurrence avec mes clients ?",
            answer:
                "Absolument aucun. PROVENCE PAIE est exclusivement dédié à l'accompagnement des cabinets\n" +
                "d'expertise comptable. Notre engagement est contractuel : nous sommes votre partenaire. Nous nous\n" +
                "interdisons contractuellement de réaliser des prestations à vos clients."
        },
        {
            question: "Comment fonctionne concrètement la Marque Blanche ?",
            answer:
                "C’est très simple : nous agissons comme votre service social interne. Les bulletins de paie, les\n" +
                "documents RH et les échanges peuvent porter le logo et les couleurs de votre cabinet. Pour votre\n" +
                "client, c’est votre cabinet qui monte en compétence et propose un service premium."
        },
        {
            question: "Qui est l’interlocuteur du client final ?",
            answer:
                "C’est vous qui décidez. Nous adaptons notre mode de communication selon vos préférences :\n" +
                "Option A : Vous restez l'unique intermédiaire. Nous vous transmettons tous les éléments.\n" +
                'Option B : Nous intervenons en tant que votre Pôle Social dédié et échangeons directement\n' +
                "avec vos clients pour plus de réactivité."
        },
        {
            question: "L’externalisation est-elle réellement rentable pour mon cabinet ?",
            answer:
                "Oui, car nous vous accompagnons dans la définition de votre politique tarifaire. L'objectif est de\n" +
                "transformer un centre de coûts (masse salariale interne, logiciels, formation) en un centre de profit, en\n" +
                "vous permettant de marger sereinement sur nos prestations tout en garantissant une qualité\n" +
                "irréprochable."
        },
        {
            question: "Comment gérez-vous la diversité des conventions collectives ?",
            answer:
                "Nos gestionnaires de paie sont des spécialistes. Sous la supervision de notre direction (Experts-\n" +
                "Comptables et Directeurs de Cabinet), nous effectuons une veille juridique rigoureuse. Nous\n" +
                "maîtrisons un large panel de conventions collectives pour garantir une conformité totale, même sur les\n" +
                "dossiers les plus complexes."
        }
        ,
        {
            question: "Que se passe-t-il en cas de contrôle URSSAF ?",
            answer:
                "C’est l’un de nos points forts. Nous ne vous laissons pas seul. Nous préparons les documents\n" +
                "nécessaires et nous vous apportons une assistance technique complète durant toute la durée du\n" +
                "contrôle pour sécuriser les positions du cabinet et du client."
        },
        {
            question: "Comment se passe la transition de mes dossiers vers PROVENCE PAIE ?",
            answer:
                "Mme Salma NAJI IDRISSI BOUANANI et son équipe ont mis en place un processus de “onboarding” \n" +
                "sécurisé. Nous récupérons vos historiques et paramétrons les dossiers avec soin pour que le passage de\n" +
                "relais soit totalement transparent pour vos clients, sans rupture de service."
        }
    ];

    return (
        <motion.section
            className="faq-section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.22 }}
            variants={reveal}
        >
            <div className="container">
                <motion.h2 className="faq-title" variants={reveal} custom={0.05}>
                    Questions Fréquentes (FAQ)
                </motion.h2>

                <div className="faq-list">
                    {faqs.map((item, index) => (
                        <FaqItem
                            key={index}
                            question={item.question}
                            answer={item.answer}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </motion.section>
    );
}
function FaqItem({ question, answer, index }) {
    const [open, setOpen] = useState(false);

    return (
        <motion.div
            className={`faq-item ${open ? 'open' : ''}`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={reveal}
            custom={index * 0.05}
        >
            <button className="faq-question" onClick={() => setOpen(!open)}>
                {question}
                <span className="icon">{open ? '−' : '+'}</span>
            </button>
            <AnimatePresence initial={false}>
                {open && (
                    <motion.p
                        className="faq-answer"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto', transition: { duration: 0.28, ease: 'easeOut' } }}
                        exit={{ opacity: 0, height: 0, transition: { duration: 0.22 } }}
                    >
                        {answer}
                    </motion.p>
                )}
            </AnimatePresence>
        </motion.div>
    );
}